import {
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Box,
  CircularProgress
} from "@mui/material";
import {
    FETCH_CLIENT_TIMESHEET_TEMPLATES_V2_NEW,
  FETCH_CLIENT_TIMESHEET_UD_FIELDS_NEW,
  SAVE_CLIENT_TIMESHEETS_NEW_CREW,
  SAVE_CLIENT_UD_FIELDS_VALUES
} from "../../../constant/Apipath";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { Postrequestcall } from "../../../request/Postrequest";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect, useState } from "react";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import { CrewTimesheetForemanEntry } from "./CrewForemanEntry";
import CrewTimesheetEmployeeClockInClockOut from "./CrewClockInMonitor";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import ClientTimesheetEmployeesModal from "../shared/modals/SelectEmployeesModal";
import ClientTimesheetActivitiesModal from "../shared/modals/SelectActivitiesModal";
import TimesheetSkeletonLoader from "../shared/components/TimesheetSkeletonLoader";

import SearchIcon from "@mui/icons-material/Search";
import SelectJob from "../shared/modals/SelectJobModal";
import { BIGrey } from "../../../assets/helpers";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";

let CLIENT_COLOR = "#000000";

const getudFieldsString = (data) => {
  try {
    if (!data?.length) return "";

    const fieldsObject = data.reduce((acc, item) => {
      acc[item.id] = item.fieldDefaultValue === "true" ? 1 : 0;
      return acc;
    }, {});

    return JSON.stringify(fieldsObject);
  } catch (error) {
    console.error("getudFieldsString-> Error processing UD fields:", error);
    return "";
  }
};

export default function ClientTimesheetCrewComponent({
  modelState,
  setModelState,
  handleClose,
  templateId,
  reloadData
}) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const TOKEN = loginData?.accessToken;
  CLIENT_COLOR = selectedClientData?.AccentColor;
  const USER_ID = loginData?.userInformation?.UserId;

  const [date, setDate] = useState(dayjs());
  const [manual, setManual] = useState(false);
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [isSwitchOn, setIsSwitchOn] = useState("manually");
  const [activityList, setActivityList] = useState([]);
  const [selectedValue, setSelectedValue] = useState({});

  const [employeesList, setEmployeesList] = useState([]);
  const [selectEmployees, setSelectEmployees] = useState(false);
  const [clientTimesheetId, setClienttimesheetId] = useState(0);
  const [selectActivities, setSelectActivities] = useState(false);

  const [openEmployee, setOpenemployee] = useState(true);
  const [openJob, setOpenjob] = useState(false);

  const [clockIn, setClockin] = useState(false);
  const [loader, setLoader] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const [fromJob, setFromjob] = useState(false);
  const [fromActivity, setFromActivity] = useState(true);
  const [firstStep, setFirstStep] = useState(true);

  const {
    TEXT_DATE,
    TEXT_JOB,
    TEXT_SEARCH_JOB,
    TEXT_ACTIVITIES,
    TEXT_SELECT_ACTIVITIES,
    TEXT_EMPLOYEE,
    TEXT_SELECT_EMPLOYEES,
    TEXT_QUESTION_TIMESHEET,
    TEXT_MANUALLY_ENTER_HOURS,
    TEXT_EMPLOYEES_CLOCKIN_OUT,
    BUTTON_NEXT,
    TEXT_CREATE_NEW_TIMESHEET,
    TEXT_TODAY
  } = ClientEnglishFallback?.AddTimesheetModal(multiLanguageData?.AddTimesheetModal || {});

  const [forEditEmployees, setForEditEmployees] = useState({
    isEdit: false,
    data: {},
    form: "Crew"
  });
  const [forEditActivities, setForEditActivities] = useState({
    isEdit: false,
    data: {},
    form: "Crew"
  });

  useEffect(() => {
    const callInitialdata = async () => {
      setLoader(true);
      if (templateId === 0) {
        if (firstStep) {
          setFirstStep(false);
          setOpenjob(true);
        }
      }
      if (templateId !== 0) await getTemplateData();
      setLoader(false);
    };
    callInitialdata();
  }, [inputValue]);

  const getTemplateData = async () => {
    try {
      const fetchParams = {
        PageNr: 1,
        NrOfRecPerPage: 0,
        FullSearch: "",
        UserId: USER_ID,
        IncludeRecordNr: false,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            ClientEmployeeId: selectedClientData?.ClientEmployeeId,
            id: templateId
          }
        ]
      };
      const getResponse = await Postrequestcall(
        FETCH_CLIENT_TIMESHEET_TEMPLATES_V2_NEW,
        fetchParams,
        TOKEN
      );
      if (getResponse.status === 200) {
        let getData = getResponse?.data?.data[0] ?? [];
        let activityList = getData?.templateActivitiesList?.map((item) => {
          return {
            ...item,
            id: item?.activityId,
            labourActivityCode: item?.activityCode,
            labourActivityName: item?.activityName
          };
        });
        setActivityList(activityList || []);
        let employeeList = getData?.templateEmployeesList?.map((item) => {
          return {
            ...item,
            id: item?.clientEmployeeId,
            clientEmployeeId: item?.clientEmployeeId,
            mileage: "",
            mileageUnit: "km",
            firstName: item?.clientEmployeeName
          };
        });
        setEmployeesList(employeeList);
        setInputValue(`${getData?.clientJobCode} - ${getData?.clientJobName} `);
        setSelectedValue({
          clientEmployeeId: selectedClientData?.ClientEmployeeId,
          clientJobCodeId: getData?.clientJobId
        });
      }
    } catch (error) {
      console.error("Error fetching timesheet templates:", error);
    } finally {
    }
  };


  const clearTheData = () => {
    setDate(dayjs());
    setSelectedValue({});
    setInputValue("");
    setSelectActivities(false);
    setSelectEmployees(false);
    setActivityList([]);
    setEmployeesList([]);
    setForEditEmployees({
      isEdit: false,
      data: {},
      form: "Crew"
    });
    setForEditActivities({
      isEdit: false,
      data: {},
      form: "Crew"
    });
  };

  const onNextPressed = async () => {
    setBtnLoader(true);
    try {
      const actIds = activityList?.map((a) => a.id).filter(id => id).join(",") || "";
      const empIds = employeesList?.map((e) => e.clientEmployeeId).filter(id => id).join(",") || "";

      const udPayload = {
        ClientId: selectedClientData?.ClientId,
        JobList: selectedValue?.clientJobCodeId ? selectedValue.clientJobCodeId.toString() : "",
        ActivityList: actIds,
        EmployeeList: empIds
      };

      let udRes = await Postrequestcall(FETCH_CLIENT_TIMESHEET_UD_FIELDS_NEW, udPayload, TOKEN);
      let jobUdFields = udRes?.data?.data?.jobUdFields || [];
      let actUdFields = udRes?.data?.data?.activityUdFields || [];
      let empUdFields = udRes?.data?.data?.employeeUdFields || [];

      const buildUdFieldsString = (fields, entityId) => {
        const obj = {};
        fields.filter(f => f.entityRecordId === 0 || f.entityRecordId === entityId).forEach(f => {
          let valStr = f.fieldDefaultValue !== undefined ? f.fieldDefaultValue.toString() : "";
          if (valStr.trim() !== "") {
            obj[f.id] = valStr;
          }
        });
        return Object.keys(obj).length > 0 ? JSON.stringify(obj) : "";
      };

      const jobUdFieldsStr = buildUdFieldsString(jobUdFields, selectedValue.clientJobCodeId);

      const saveList = activityList?.map((act) => {
        const actUdFieldsStr = buildUdFieldsString(actUdFields, act?.id);
        const activityEmployeesList = employeesList?.map((emp) => {
          const empUdFieldsStr = buildUdFieldsString(empUdFields, emp?.clientEmployeeId);
          return {
            id: 0,
            clientEmployeeId: emp?.clientEmployeeId,
            hours: 0,
            employeeMileage: emp?.mileage === "" ? 0 : parseFloat(emp?.mileage) || 0,
            employeeMileageUnit: emp?.mileageUnit || "km",
            employeeUDFields: "",
            deleted: false,
            clockInTime: "00:00:00",
            clockOutTime: "00:00:00",
            isHoursEdit: false,
            isEmployeeUDField: empUdFieldsStr !== "" ? true : false,
            employeeStatusId: 4
          };
        });

        return {
          id: 0,
          userId: USER_ID,
          clientId: selectedClientData?.ClientId,
          date: date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss.SSS") : "",
          statusId: 4,
          typeId: isSwitchOn === "clockinandout" ? 4 : 2,
          clientJobId: selectedValue?.clientJobCodeId,
          jobNotes: "",
          jobUDFields: "",
          clientActivityId: act?.id,
          activityQty: 0,
          activityQtyUnit: act.quantityUnit || "",
          activityNotes: "",
          activityUDFields: "",
          deleted: false,
          isJobUDField: jobUdFieldsStr !== "" ? true : false,
          isActivityUDField: actUdFieldsStr !== "" ? true : false,
          activityEmployeesList: activityEmployeesList || []
        };
      }) || [];

      const timesheetObj = {
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: saveList
      };

      const getResponse = await Postrequestcall(
        SAVE_CLIENT_TIMESHEETS_NEW_CREW,
        timesheetObj,
        loginData?.accessToken
      );
      if (getResponse.status === 201) {
        const responseData = getResponse?.data?.data || [];
        let clientTimesheetId = responseData[0]?.objData?.ClientTimesheetId ?? 0;
        let clientTimesheetJobId = responseData[0]?.objData?.ClientTimesheetJobId ?? 0;

        let udSaveList = [];

        jobUdFields.filter(f => f.entityRecordId === 0 || f.entityRecordId === selectedValue?.clientJobCodeId).forEach(field => {
          let valStr = field.fieldDefaultValue !== undefined ? field.fieldDefaultValue.toString() : "";
          udSaveList.push({
            Id: 0,
            ClientId: selectedClientData?.ClientId,
            ClientEmployeeId: selectedClientData?.ClientEmployeeId,
            AppId: 11,
            AppRecordId: clientTimesheetId,
            AssociatedRecordId: clientTimesheetJobId,
            AppEntityId: field.appEntityId || 1,
            EntityRecordId: selectedValue?.clientJobCodeId || 0,
            UDFieldId: field.id,
            Value: valStr,
            ModifiedBy: USER_ID
          });
        });

        employeesList?.forEach(emp => {
          empUdFields.filter(f => f.entityRecordId === 0 || f.entityRecordId === emp.clientEmployeeId).forEach(field => {
            let valStr = field.fieldDefaultValue !== undefined ? field.fieldDefaultValue.toString() : "";
            let clientTimesheetJobsEmployeeId = 0;
            for (let res of responseData) {
              let foundEmp = res?.objData?.Employees?.find(e => e.ClientEmployeeId === emp.clientEmployeeId);
              if (foundEmp) {
                clientTimesheetJobsEmployeeId = foundEmp.ClientTimesheetJobsEmployeeId;
                break;
              }
            }

            udSaveList.push({
              Id: 0,
              ClientId: selectedClientData?.ClientId,
              ClientEmployeeId: selectedClientData?.ClientEmployeeId,
              AppId: 11,
              AppRecordId: clientTimesheetId,
              AssociatedRecordId: clientTimesheetJobsEmployeeId,
              AppEntityId: field.appEntityId || 2,
              EntityRecordId: emp.clientEmployeeId,
              UDFieldId: field.id,
              Value: valStr,
              ModifiedBy: USER_ID
            });
          });
        });

        activityList?.forEach((act, index) => {
          actUdFields.filter(f => f.entityRecordId === 0 || f.entityRecordId === act.id).forEach(field => {
            let valStr = field.value !== undefined ? field.value.toString() : (field.fieldDefaultValue !== undefined ? field.fieldDefaultValue.toString() : "");
            let clientTimesheetJobActivityId = responseData[index]?.objData?.ClientTimesheetJobActivityId ?? 0;

            udSaveList.push({
              Id: 0,
              ClientId: selectedClientData?.ClientId,
              ClientEmployeeId: selectedClientData?.ClientEmployeeId,
              AppId: 11,
              AppRecordId: clientTimesheetId,
              AssociatedRecordId: clientTimesheetJobActivityId,
              AppEntityId: field.appEntityId || 3,
              EntityRecordId: act.id,
              UDFieldId: field.id,
              Value: valStr,
              ModifiedBy: USER_ID
            });
          });
        });

        if (udSaveList.length > 0) {
          const udSavePayload = {
            UserId: USER_ID,
            ReturnRecordId: true,
            ReturnRecordError: true,
            SaveList: udSaveList
          };
          await Postrequestcall(SAVE_CLIENT_UD_FIELDS_VALUES, udSavePayload, TOKEN);
        }

        if (isSwitchOn === "clockinandout") {
          setClockin(true);
          setManual(false);
        } else {
          setClockin(false);
          setManual(true);
        }
        setClienttimesheetId(clientTimesheetId);
      }
    } catch (error) {
    } finally {
      setBtnLoader(false);
    }
  };

  const returnSelectedemp = () => {
    let getList = employeesList?.map((item) => {
      return {
        ...item,
        id: item?.clientEmployeeId
      };
    });
    return getList;
  };

  const onEmployeeUdfieldchange = (e, emp, udField, from) => {
    let updatedList = employeesList?.map((item) => {
      if (item.clientEmployeeId === emp.clientEmployeeId) {
        let getUpdatedudfield = item.udfields?.map((ud) => {
          if (ud.id === udField.id) {
            return {
              ...ud,
              checked: ud.checked ? false : true
            };
          }
          return ud;
        });
        return {
          ...item,
          udfields: getUpdatedudfield
        };
      }
      return item;
    });
    setEmployeesList(updatedList);
  };

  const onActivityUdfieldchange = (e, act, udField, from) => {
    let updatedList = activityList?.map((item) => {
      if (item.id === act.id) {
        let getUpdatedudfield = item.udfields?.map((ud) => {
          if (ud.id === udField.id) {
            return {
              ...ud,
              checked: ud.checked ? false : true
            };
          }
          return ud;
        });
        return {
          ...item,
          udfields: getUpdatedudfield
        };
      }
      return item;
    });
    setActivityList(updatedList);
  };

  return (
    <>
      <Stack sx={{ display: "flex", mb: 1, justifyContent: "space-between", alignItems: "center" }} direction={"row"}>
        {modelState == "HOME" && (
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
            {TEXT_CREATE_NEW_TIMESHEET}
          </Typography>
        )}
        {modelState != "HOME" && (
          <IconButton
            size="small"
            onClick={() => {
              clearTheData();
              setModelState("HOME");
            }}>
            <ArrowBackIcon />
          </IconButton>
        )}
        <IconButton
          onClick={() => {
            handleClose();
            clearTheData();
            setModelState("HOME");
          }}
          style={{ padding: "4px" }}>
          <CloseIcon />
        </IconButton>
      </Stack>
      {loader ? (
        <TimesheetSkeletonLoader variant="modal" />
      ) : (
        <>
      <Grid container spacing={1}>
        <Grid size={12}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Typography>{TEXT_DATE}</Typography>
            <Box
              onClick={() => setOpen(true)}
              sx={{
                height: "40px",
                backgroundColor: "#e4e4e4",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0 10px",
                cursor: "pointer"
              }}>
              <span>
                {date && dayjs.isDayjs(date)
                  ? dayjs(date).isSame(dayjs(), "day")
                    ? `${dayjs(date).format("MMM DD, YYYY")} (Today)`
                    : dayjs(date).format("MMM DD, YYYY")
                  : dayjs().format("MMM DD, YYYY")}
              </span>
              <InsertInvitationIcon
                sx={{
                  color: selectedClientData?.AccentColor,
                  cursor: "pointer"
                }}
              />
            </Box>
            <MobileDatePicker
              open={open}
              onOpen={() => setOpen(true)}
              onClose={() => setOpen(false)}
              format="MMM DD, YYYY"
              value={date}
              onChange={(newValue) => setDate(newValue)}
              defaultValue={dayjs()}
              sx={{ display: "none" }} // Hide the actual picker input
            />
          </LocalizationProvider>
        </Grid>
        <Grid size={12}>
          <Typography sx={{ margin: 0 }} variant="subtitle1" gutterBottom>
            {TEXT_JOB}
          </Typography>
          <TextField
            placeholder={TEXT_SEARCH_JOB}
            size="small"
            sx={{
              backgroundColor: "#e4e4e4",
              borderRadius: "10px",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none"
              }
            }}
            slotProps={{
              input: {
                readOnly: true,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }
            }}
            value={inputValue}
            fullWidth
            variant="outlined"
            onClick={() => {
              setOpenjob(true);
            }}
          />
        </Grid>
        <Grid
          container
          size={12}
          sx={{
            maxHeight: "400px",
            overflow: "scroll",
            scrollbarWidth: "none"
          }}>
          <Grid size={12}>
            <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction="row">
              <Typography sx={{ fontWeight: "bold" }}>{TEXT_ACTIVITIES}</Typography>
              {activityList?.length != 0 && (
                <Typography
                  onClick={() => {
                    if (
                      selectedValue?.clientJobCodeId !== 0 &&
                      typeof selectedValue?.clientJobCodeId !== "undefined"
                    ) {
                      setFromjob(false);
                      setSelectActivities(true);
                    } else {
                      alert("Select a Job");
                      setOpenjob(true);
                    }
                    setFromActivity(false);
                  }}
                  sx={{
                    cursor: "pointer",
                    color: CLIENT_COLOR
                  }}>
                  {TEXT_SELECT_ACTIVITIES}
                </Typography>
              )}
            </Stack>
            {activityList?.length == 0 && (
              <Button
                fullWidth
                onClick={() => {
                  if (
                    selectedValue?.clientJobCodeId !== 0 &&
                    typeof selectedValue?.clientJobCodeId !== "undefined"
                  ) {
                    setFromjob(false);
                    setSelectActivities(true);
                  } else {
                    alert("Select a Job");
                    setOpenjob(true);
                  }
                  setFromActivity(false);
                }}
                sx={{
                  backgroundColor: CLIENT_COLOR,
                  color: "white",
                  borderRadius: "10px",
                  textTransform: "none"
                }}>
                {TEXT_SELECT_ACTIVITIES}
              </Button>
            )}
            <Grid sx={{ mt: 1 }} container spacing={1}>
              {activityList?.map((item, index) => {
                return (
                  <ListingComponent
                    from={"activityList"}
                    activityList={activityList}
                    setActivityList={setActivityList}
                    key={index}
                    item={item}
                    index={index}
                    onActivityUdfieldchange={onActivityUdfieldchange}
                  />
                );
              })}
            </Grid>
          </Grid>
          <Grid size={12}>
            <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction="row">
              <Typography sx={{ fontWeight: "bold" }}>{TEXT_EMPLOYEE}</Typography>
              {employeesList?.length != 0 && (
                <Typography
                  onClick={() => {
                    setFromActivity(false);
                    setSelectEmployees(true);
                  }}
                  sx={{
                    cursor: "pointer",
                    color: CLIENT_COLOR,
                    marginTop: "10px"
                  }}>
                  {TEXT_SELECT_EMPLOYEES}
                </Typography>
              )}
            </Stack>
            {employeesList?.length == 0 && (
              <Button
                fullWidth
                onClick={() => {
                  setFromActivity(false);
                  setSelectEmployees(true);
                }}
                sx={{
                  backgroundColor: CLIENT_COLOR,
                  color: "white",
                  borderRadius: "10px",
                  textTransform: "none"
                }}>
                {TEXT_SELECT_EMPLOYEES}
              </Button>
            )}
            <Grid sx={{ mt: 1 }} container spacing={1}>
              {employeesList?.map((item, index) => {
                return (
                  <ListingComponent
                    from={"employeeList"}
                    employeesList={employeesList}
                    setEmployeesList={setEmployeesList}
                    key={index}
                    item={item}
                    index={index}
                    onEmployeeUdfieldchange={onEmployeeUdfieldchange}
                  />
                );
              })}
            </Grid>
            <Stack sx={{ justifyContent: "space-between", alignItems: "center", marginTop: "10px" }} direction={"row"}>
              <FormControl>
                <FormLabel color={BIGrey}>{TEXT_QUESTION_TIMESHEET}</FormLabel>
                <RadioGroup
                  value={isSwitchOn}
                  onChange={(e) => {
                    setIsSwitchOn(e.target.value);
                  }}
                  sx={{
                    padding: "10px"
                  }}>
                  <FormControlLabel
                    value="manually"
                    checked={isSwitchOn === "manually" ? true : false}
                    defaultChecked={true}
                    control={
                      <Radio
                        sx={{
                          "&.Mui-checked": {
                            color: CLIENT_COLOR
                          }
                        }}
                      />
                    }
                    label={TEXT_MANUALLY_ENTER_HOURS}
                  />
                  <FormControlLabel
                    value="clockinandout"
                    checked={isSwitchOn === "clockinandout" ? true : false}
                    control={
                      <Radio
                        sx={{
                          "&.Mui-checked": {
                            color: CLIENT_COLOR
                          }
                        }}
                      />
                    }
                    label={TEXT_EMPLOYEES_CLOCKIN_OUT}
                  />
                </RadioGroup>
              </FormControl>
            </Stack>
          </Grid>
        </Grid>

        <Button
          fullWidth
          onClick={() => onNextPressed()}
          disabled={
            btnLoader ||
            selectedValue?.clientJobCodeId === 0 ||
              employeesList?.length === 0 ||
              activityList?.length === 0
              ? true
              : false
          }
          sx={{
            backgroundColor:
              btnLoader ||
              selectedValue?.clientJobCodeId === 0 ||
                employeesList?.length === 0 ||
                activityList?.length === 0
                ? "lightgrey"
                : CLIENT_COLOR,
            color: "white",
            borderRadius: "10px",
            textTransform: "none"
          }}>
          {btnLoader ? <CircularProgress size={24} color="inherit" /> : BUTTON_NEXT}
        </Button>
      </Grid>

      {openJob && (
        <SelectJob
          isOpen={openJob}
          onClose={() => setOpenjob(false)}
          setInputValue={setInputValue}
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
          setSelectActivities={setSelectActivities}
          setFromjob={setFromjob}
          setActivityList={setActivityList}
        />
      )}

      {manual && (
        <CrewTimesheetForemanEntry
          isOpen={manual}
          onClose={() => {
            setModelState("HOME");
            handleClose();
            clearTheData();
            reloadData();
          }}
          clientTimesheetId={clientTimesheetId}
        />
      )}

      {clockIn && (
        <CrewTimesheetEmployeeClockInClockOut
          isOpen={clockIn}
          clientTimesheetId={clientTimesheetId}
          onClose={() => {
            setModelState("HOME");
            handleClose();
            clearTheData();
            reloadData();
          }}
        />
      )}

      {selectEmployees && (
        <ClientTimesheetEmployeesModal
          setSelectedEmp={setEmployeesList}
          empList={returnSelectedemp()}
          isEditdetails={forEditEmployees}
          isOpen={selectEmployees}
          setSelectEmployees={setSelectEmployees}
          onClose={
            fromActivity
              ? () => {
                setSelectActivities(true);
                setSelectEmployees(false);
              }
              : () => {
                setSelectEmployees(false);
              }
          }
        />
      )}

      {selectActivities && (
        <ClientTimesheetActivitiesModal
          setSelectedActivityList={setActivityList}
          isEditdetails={forEditActivities}
          isOpen={selectActivities}
          onClose={() => setSelectActivities(false)}
          jobId={selectedValue?.clientJobCodeId}
          actList={activityList}
          fromJob={fromJob}
          setOpenjob={setOpenjob}
          openEmployee={openEmployee}
          setOpenemployee={setOpenemployee}
          setSelectEmployees={setSelectEmployees}
          jobActivities={selectedValue?.clientJobActivitiesList}
        />
      )}
      </>
      )}
    </>
  );
}

const ListingComponent = ({
  item,
  employeesList,
  setEmployeesList,
  activityList,
  setActivityList,
  index,
  from
}) => {
  const deleteEmployee = (getItem) => {
    if (from === "employeeList") {
      let getUpdatelist = employeesList?.filter(
        (item) => item?.clientEmployeeId !== getItem?.clientEmployeeId
      );
      setEmployeesList(getUpdatelist);
    } else {
      let getUpdatelist = activityList?.filter((item) => item?.id !== getItem?.id);
      setActivityList(getUpdatelist);
    }
  };

  return (
    <Grid
      size={12}
      spacing={1}
      sx={{
        border: "1px solid #e4e4e4",
        padding: "10px",
        borderRadius: "15px",
        cursor: "pointer"
      }}
      container
      key={index}
      style={{ display: "flex", justifyContent: "space-between" }}>
      <Grid size={12}>
        <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction={"row"} width={"100%"}>
          <Typography
            sx={{
              wordBreak: "break-all",
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 1,
              fontSize: "17px",
              fontWeight: "bold"
            }}>
            {from === "employeeList"
              ? item?.firstName + " " + (item?.lastName ? item?.lastName : "")
              : item?.labourActivityCode + " " + item.labourActivityName}
          </Typography>
          <IconButton size="small" onClick={() => deleteEmployee(item)}>
            <CloseIcon
              sx={{
                color: CLIENT_COLOR
              }}
            />
          </IconButton>
        </Stack>
      </Grid>
      {/* <Grid size={12}>
        {item?.udfields?.map((udField) => (
          <FormControlLabel
            control={
              <Checkbox
                checked={udField?.checked}
                sx={{
                  color: CLIENT_COLOR,
                  "&.Mui-checked": {
                    color: CLIENT_COLOR
                  }
                }}
                onChange={
                  from === "employeeList"
                    ? (e) => onEmployeeUdfieldchange(e, item, udField, from)
                    : (e) => onActivityUdfieldchange(e, item, udField, from)
                }
              />
            }
            label={udField?.fieldLabel}
          />
        ))}
      </Grid> */}
    </Grid>
  );
};
